import { TranslationService } from "../../../../../services/TranslationService";
import { AIBillingUsageItem } from "../../../../../services/AIBillingService";
import CompanyService from "../../../../../services/CompanyService";
import {
  formatCostUsd,
  formatIsoDateTime,
  formatTokens,
  getAgentTypeLabel,
  resolveUserName
} from "../AIBillingFormat";

const AIBillingUsageTable = ({
  items,
  showTotalTokens = false,
  roundedBottom = true
}: {
  items: AIBillingUsageItem[];
  showTotalTokens?: boolean;
  /** false cuando un Paginator sigue inmediatamente debajo: es el que aporta
   * el borde inferior redondeado para que ambos formen una sola caja. */
  roundedBottom?: boolean;
}) => {
  const { translate } = TranslationService;
  const users = CompanyService.getUsers();

  return (
    <div className="table-loader-container">
      <div
        className={
          "tableContainer overflow-x-auto" +
          (roundedBottom ? " rounded-bottom" : "")
        }
      >
        <table className="table genericTable table-ellipsis">
          <thead>
            <tr>
              <th>{translate.Date}</th>
              <th>{translate.AIUsageAgent}</th>
              <th>{translate.User}</th>
              <th className="header-numeric">{translate.AITokensInOut}</th>
              {showTotalTokens && (
                <th className="header-numeric">{translate.AITotalTokens}</th>
              )}
              <th className="header-numeric">{translate.AICostUsd}</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr key={`${item.date}_${index}`}>
                <td>{formatIsoDateTime(item.date)}</td>
                <td>{getAgentTypeLabel(item.agentType)}</td>
                <td>{resolveUserName(item.userId, users)}</td>
                <td className="text-end">
                  {`${formatTokens(item.tokensIn)} / ${formatTokens(item.tokensOut)}`}
                </td>
                {showTotalTokens && (
                  <td className="text-end">
                    {formatTokens(item.tokensIn + item.tokensOut)}
                  </td>
                )}
                <td className="text-end">
                  {formatCostUsd(item.amount)}
                  {item.free && (
                    <div>
                      <span className="badge bg-secondary badge-success">
                        {translate.AIBonified}
                      </span>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AIBillingUsageTable;
